import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
    AccountSelection,
    SimplifiedSelectDateRange,
    H1,
    H2,
    H3,
    ContentHolder,
    SelectGroup
} from "commons";
import { isPrintMode, getDebugPrinter, getPdfPrinter, getUuid } from "commons/src/QueryParameter";
import { convertIdToReal } from "commons/src/NuDateUtils";
import { isInsideGoReactNativeApp } from "commons/src/helpers/ReactNativeAppHelpers";

import { routes } from "../../helpers/RouteHelpers";
import { MainFrame } from "../../../../../transactions/src/MainFrame";

export function Transactions({ accounts = {}, accountNum, history, rangeId, theme }) {
    const handleSubmit = (accountNum, rangeId) =>
        history.push(routes.client.transactions({ accountNum, rangeId }));

    const handleAccountChange = event => handleSubmit(event.target.value, rangeId);
    const handleDateChange = (_e, dateSelection) => handleSubmit(accountNum, dateSelection.rangeId);

    const accountId = accounts[accountNum]?.accountId?.toString?.() || "default";
    const dateRange = convertIdToReal(rangeId);
    const showHeader = !isInsideGoReactNativeApp();

    const accountLabel = accounts?.[accountNum]?.wrapperType
        ? `${accounts[accountNum].wrapperType} ${accountNum}`
        : accountNum;
    const alias = accounts?.[accountNum]?.alias;

    return (
        <ContentHolder>
            {showHeader ? <H1>Transactions</H1> : null}
            <SelectGroup>
                <AccountSelection handleSelect={handleAccountChange} value={accountNum} />
                <SimplifiedSelectDateRange value={rangeId} dateChanged={handleDateChange} />
            </SelectGroup>
            <Container>
                {accountNum !== "default" ? (
                    <H2 data-testid="account-label">{accountLabel}</H2>
                ) : null}
                {alias ? <AccountAlias data-testid="account-alias">{alias}</AccountAlias> : null}
                <MainFrame
                    accountId={accountId}
                    dateSelection={dateRange}
                    isClientPortal
                    isPrintMode={isPrintMode()}
                    printHost={getDebugPrinter(window.location)}
                    pdfExporter={getPdfPrinter(window.location)}
                    uuid={getUuid(window.location)}
                    theme={theme}
                />
            </Container>
        </ContentHolder>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const AccountAlias = styled(H3)`
    margin-bottom: 0;
`;

Transactions.propTypes = {
    accounts: PropTypes.object,
    accountNum: PropTypes.string,
    history: PropTypes.shape({
        push: PropTypes.func
    }),
    rangeId: PropTypes.string,
    theme: PropTypes.object
};
